<template>
<CContainer>
<CRow>
    <CCol col="12">
        <CCard>
            <Loading />
            <Message />

            <CCardBody>
                <h5 class="d-block mb-4">کمیسیون پله‌ای در ازای فروش</h5>

                <span>
                    مبنای محاسبات:
                    <CSelect :value="saleTier.base" class="d-inline-block" @update:value="value => saleTier.base = value" :options="CommissionMetricBaseOption" />
                </span>

                <span>
                    نحوه تغییر پلکانها:
                    <CSelect :value="saleTier.tier_type" class="d-inline-block" @update:value="value => saleTier.tier_type = value" :options="CommissionTierTypeOption" />
                </span>

                <CAlert color="warning">
                    ساختار کمیسیون‌های شما با توجه کمیسیون پیش‌فرض شما مشخص می‌شود. برای ایجاد سطوح بالاتر از سطح پیش‌فرض، مقادیر زیر را تکمیل نمایید.
                </CAlert>
                <div>
                    <p class="small" v-for="index in 10" :key="index">
                        در صورتی که {{ commissionMetricBaseStr(saleTier.base) }} بزرگتر مساوی
                        <CInput addInputClasses="custom-inp-style" class="d-inline-block ltr mb-0" style="font-size:70%" type="number" v-model="saleTier.metrics[index - 1].gte" />
                        شود؛ مقدار کمیسیون
                        <span v-if="saleTier.tier_type === CommissionTierType.FIXED">برابر با</span>
                        {{ commissionTierTypeStr(saleTier.tier_type) }}
                        <CInput addInputClasses="custom-inp-style" class="d-inline-block ltr mb-0 mfe-1" style="font-size:70%" type="number" v-model="saleTier.metrics[index - 1].tier_value" />
                        خواهد شد.
                    </p>
                </div>
            </CCardBody>
        </CCard>
        <CButton @click="editOrCreateTier" type="submit" color="primary" class="px-4 float-right">{{ $t('submit') }}</CButton>
    </CCol>
</CRow>
</CContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { filterObject } from '@/common/objects'
import { CommissionModel, CommissionType, CommissionTierType, CommissionMetricBase } from '@/constants'
import { CommissionTierTypeOption, CommissionMetricBaseOption } from '@/common/data'
import { commissionMetricBaseStr, commissionTierTypeStr } from './partials/methods'

export default {
    name: 'Tiers',

    data() {
        return {
            CommissionTierType,
            CommissionTierTypeOption,
            CommissionMetricBaseOption,
			storeId: this.$route.params.store_id,
            modal: {
                item: {}
            },
            saleTierCommission: {
                tier_type: CommissionTierType.FIXED,
                base: CommissionMetricBase.COMMISSIONS_FOR_THE_CURRENT_MONTH,
                metrics: [
                    {
                        gte: '',
                        tier_value: '',
                    },
                    {
                        gte: '',
                        tier_value: '',
                    },
                    {
                        gte: '',
                        tier_value: '',
                    },
                    {
                        gte: '',
                        tier_value: '',
                    },
                    {
                        gte: '',
                        tier_value: '',
                    },
                    {
                        gte: '',
                        tier_value: '',
                    },
                    {
                        gte: '',
                        tier_value: '',
                    },
                    {
                        gte: '',
                        tier_value: '',
                    },
                    {
                        gte: '',
                        tier_value: '',
                    },
                    {
                        gte: '',
                        tier_value: '',
                    },
                ]
            },
        }
    },

    computed: {
        ...mapGetters({
			commissions: 'v2commission/commissions',
        }),
        saleTier: {
            get() {
                const saleTiers = filterObject(
                    this.commissions,
                    commission => commission.model === CommissionModel.TRANSACTION_TIER && commission.type === CommissionType.SALE
                )

                const index = Object.keys(saleTiers)[0]

                if (index) {
                    this.saleTierCommission = saleTiers[index]
                    for(let i = 0; i < 10; i++) {
                        if (!this.saleTierCommission.metrics[i]) {
                            this.saleTierCommission.metrics[i] = {
                                gte: '',
                                tier_value: '',
                            }
                        }
                    }
                }

                return this.saleTierCommission
            },
            set(val) {
                this.saleTierCommission = val
            }
        },
        // leadTiers() {
        //     return filterObject(
		// 		this.commissions,
		// 		commission => commission.model === CommissionModel.TRANSACTION_TIER && commission.type === CommissionType.LEAD
		// 	)
        // }
    },

    methods: {
        ...mapActions({
			create: 'v2commission/create',
			edit: 'v2commission/edit',
			setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
		}),
        commissionMetricBaseStr,
        commissionTierTypeStr,
        editOrCreateTier() {
            this.setShowLoading()
            this.resetMsg()

			const data = {
				id: this.saleTier.id || undefined,
                tier_type: this.saleTier.tier_type,
                base: this.saleTier.base,
                metrics: this.saleTier.metrics.filter(metric => metric.gte !== null && metric.tier_value > 0),
				model: this.saleTier.model || CommissionModel.TRANSACTION_TIER,
				store_id: this.saleTier.store_id || this.storeId,
                type: CommissionType.SALE
			}

			const form = data.id ? this.edit(data) : this.create(data)

			form
				.then(res => {
					this.setShowLoading(false)
				}).catch(result => {
					this.setShowLoading(false)
					this.setMsg({
						content: this.$t('tags.'+result.tag),
						type: 'danger'
					})
				})
        }
    }
}
</script>

<style lang="scss" scoped>
div.form-group::v-deep .custom-inp-style {
    width: 100px;
    height: 25px;
}
</style>